import React, { useEffect, useRef, useState } from "react";
import "../Styles/index.scss";
import { EmptyListPage, ErrorSuccessModal, TableLoader } from "../../commons";
import {
  ITEM_TABLE_HEADERS,
  OUTWARD_SUPPLIES_HEADERS,
} from "../../../constant/tableHeadersConstants/gst/OutwardHeadersConstant";
import MainTableBody from "../GstTables/MainTableBody";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import GstTableHeader from "../common/GstTableHeader";
import {
  getOutwardsListAction,
  resetGstMessage,
  resetGstModuleError,
  resetGstModuleFetching,
  resetGstModuleSuccess,
  resetGstrOneData,
  resetGstrTwoAReturnsData,
  resetOutwardsData,
  resetTotalCgstAmount,
  resetTotalIgstAmount,
  resetTotalInvoiceValue,
  resetTotalOutwardsListCount,
  resetTotalSgstAmount,
  resetTotalTaxableValue,
  updateOutwardListAction,
} from "../../../redux/gstModule";
import {
  FilterType,
  GetOutwardDataPayload,
  GstRadioTypes,
  OutwardsDataType,
  UpdateOutwardDataPayload,
} from "../../../commonTypes/gstTypes";
import { resetSession } from "../../../redux/auth";
import OutwardHeader from "./OutwardHeader";
import ScrollToTop from "../../commons/ScrollToTop";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import useDebounce from "../../../customHooks/useDebounce";
import {
  checkFormatDdMmYyyy,
  formatDate,
  formatDateInYear,
  getCurrentFinancialYear,
  handleDate,
  previousFinancialYear,
} from "../../../utils/commonFunctions";
import GstTotalHeader from "../common/GstTotalHeader";
import { formatGstDate, setMultiDataFunction } from "../common";
import { NoFile } from "../../../assets/images";
import { Col, Row } from "reactstrap";
import MultiSelect from "../../commons/MultiSelect";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { LoginResponseType } from "../../../redux/auth/authTypes";

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null | undefined;
  statusCode: number | null;
  handleSetIcon: () => any;
  outwardsData?: OutwardsDataType[];
  loginData: LoginResponseType;
  totalOutwardsListCount: number;
  message: string | null;
  totalCgstAmount: number;
  totalIgstAmount: number;
  totalInvoiceValue: number;
  totalSgstAmount: number;
  totalTaxableValue: number;
  // isSalesEntryPresent:boolean;
  dispatchGetOutwardsData: (data: GetOutwardDataPayload) => void;
  dispatchResetSession: () => void;
  dispatchResetGstError: () => void;
  dispatchResetGstSuccess: () => void;
  dispatchResetGstFetching: () => void;
  dispatchUpdateOutwardsData: (data: UpdateOutwardDataPayload) => void;
  dispatchResetGstMessage: () => void;
  dispatchResetOutwardData: () => void;
  dispatchResetTotalOutwardListCount: () => void;
  dispatchResetGstrOneData: () => void;
  dispatchResetTotalCgstAmount: () => void;
  dispatchResetTotalIgstAmount: () => void;
  dispatchResetTotalInvoiceValue: () => void;
  dispatchResetTotalSgstAmount: () => void;
  dispatchResetTotalTaxableValue: () => void;
  dispatchResetGstrTwoAData: () => void;
};

const OutwardSupplies = ({
  fetching,
  success,
  error,
  statusCode,
  token,
  message,
  outwardsData,
  history,
  loginData,
  totalCgstAmount,
  totalIgstAmount,
  totalInvoiceValue,
  totalSgstAmount,
  totalTaxableValue,
  handleSetIcon,
  totalOutwardsListCount,
  dispatchGetOutwardsData,
  dispatchResetGstError,
  dispatchResetGstSuccess,
  dispatchResetGstFetching,
  dispatchResetSession,
  dispatchUpdateOutwardsData,
  dispatchResetGstMessage,
  dispatchResetOutwardData,
  dispatchResetTotalOutwardListCount,
  dispatchResetGstrOneData,
  dispatchResetTotalCgstAmount,
  dispatchResetTotalIgstAmount,
  dispatchResetTotalInvoiceValue,
  dispatchResetTotalSgstAmount,
  dispatchResetTotalTaxableValue,
  dispatchResetGstrTwoAData,
}: AppProps) => {
  const [offset, setOffset] = useState<number>(0);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [text, setText] = useState("");
  const [data, setData] = useState<OutwardsDataType[]>([]);
  const [limit, setLimit] = useState<number>(20);
  const [isSalesEntryPresent, setIsSalesEntryPresent] = useMenuCheck();
  const persistData = useRef([]);
  const currentYear: number = new Date().getFullYear();
  const currentFY = getCurrentFinancialYear();
  const [toggle, setToggle] = useState<boolean>(false);
  const [apiCall, setApiCall] = useState<boolean>(false);
  const [filtersValue, setFiltersValue] = useState<FilterType>({
    sez: "",
    placeOfSupply: { label: "Select State", value: "" },
    sezTaxPayment: "",
    exports: "",
    salesType: "",
  });
  const [filters, setFilters] = useState<FilterType>({
    sez: "",
    placeOfSupply: { label: "Select State", value: "" },
    sezTaxPayment: "",
    exports: "",
    salesType: "",
  });
  const [sorting, setSorting] = useState<GstRadioTypes | undefined>({
    unique_id: "invoice_date",
    id: "invoice_date_desc",
    _id: "desc",
    name: "Invoice Date - Descending",
  });

  const [outWardDropDownData, setOutWardDropDownData] = useState(false);

  const client_code: number = history?.location?.state?.client_code
    ? history?.location?.state?.client_code
    : localStorage.getItem("client_code");

  const company_name: string = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : localStorage.getItem("company_name");

  useEffect(() => {
    setIsSalesEntryPresent("Sales Invoices", "menu");
    setData([]);
    setOffset(0);
    dispatchResetGstError();
    dispatchResetGstSuccess();
    dispatchResetGstFetching();
    dispatchResetGstMessage();
    dispatchResetOutwardData();
    dispatchResetGstrOneData();
    dispatchResetTotalCgstAmount();
    dispatchResetTotalIgstAmount();
    dispatchResetTotalInvoiceValue();
    dispatchResetTotalSgstAmount();
    dispatchResetTotalTaxableValue();
    dispatchResetGstrTwoAData();
  }, []);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: text,
        offset,
        limit,
        client_code,
        start_date:
          !startDate || startDate == "Invalid date"
            ? formatDate(`${currentFY?.split("-")[0]}-04-01`)
            : formatDate(startDate),
        end_date:
          !endDate || endDate == "Invalid date"
            ? formatDate(`${currentFY?.split("-")[1]}-03-31`)
            : formatDate(endDate),
        exports: filters?.exports,
        sez: filters?.sez,
        sez_tax_payment: filters?.sezTaxPayment,
        place_of_supply: filters?.placeOfSupply?.value,
        sales_type: filters?.salesType,
        sort_by: sorting?.unique_id,
        sort_order: sorting?._id,
      };
      if (
        token &&
        outwardsData &&
        outwardsData?.length &&
        +totalOutwardsListCount
      ) {
        if (offset < totalOutwardsListCount && apiCall) {
          dispatchGetOutwardsData(finalData);
        }
      } else if (
        token &&
        offset === 0 &&
        totalOutwardsListCount === 0 &&
        apiCall
      ) {
        dispatchGetOutwardsData(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    setOffset(0);
    if (token && apiCall) {
      dispatchResetOutwardData();
      dispatchResetTotalOutwardListCount();
      setData([]);
      let finalData = {
        token,
        search_term: text,
        offset: 0,
        limit,
        client_code,
        start_date:
          !startDate || startDate == "Invalid date"
            ? formatDate(`${currentFY?.split("-")[0]}-04-01`)
            : formatDate(startDate),
        end_date:
          !endDate || endDate == "Invalid date"
            ? formatDate(`${currentFY?.split("-")[1]}-03-31`)
            : formatDate(endDate),
        exports: filters?.exports,
        sez: filters?.sez,
        sez_tax_payment: filters?.sezTaxPayment,
        place_of_supply: filters?.placeOfSupply?.value,
        sales_type: filters?.salesType,
        sort_by: sorting?.unique_id,
        sort_order: sorting?._id,
      };
      dispatchGetOutwardsData(finalData);
    }

    if (filters?.exports) {
      setMultiDataFunction(
        filters.exports,
        "exports",
        setMultiSelectData,
        multiSelectData
      );
    }
    if (filters?.salesType) {
      setMultiDataFunction(
        filters.salesType,
        "salesType",
        setMultiSelectData,
        multiSelectData
      );
    }
    if (filters?.sez) {
      setMultiDataFunction(
        filters.sez,
        "sez",
        setMultiSelectData,
        multiSelectData
      );
    }
    if (filters?.sezTaxPayment) {
      setMultiDataFunction(
        filters.sezTaxPayment,
        "sezTaxPayment",
        setMultiSelectData,
        multiSelectData
      );
    }
    if (filters?.placeOfSupply?.value) {
      setMultiDataFunction(
        filters?.placeOfSupply?.value,
        "placeOfSupply",
        setMultiSelectData,
        multiSelectData
      );
    }
  }, [filters, sorting]);

  function getData() {
    dispatchResetOutwardData();
    dispatchResetTotalOutwardListCount();
    setData([]);
    let finalData = {
      token,
      search_term: text,
      offset: 0,
      limit,
      client_code,
      start_date:
        !startDate || startDate == "Invalid date"
          ? formatDate(`${currentFY?.split("-")[0]}-04-01`)
          : formatDate(startDate),
      end_date:
        !endDate || endDate == "Invalid date"
          ? formatDate(`${currentFY?.split("-")[1]}-03-31`)
          : formatDate(endDate),
      exports: filters?.exports,
      sez: filters?.sez,
      sez_tax_payment: filters?.sezTaxPayment,
      place_of_supply: filters?.placeOfSupply?.value,
      sales_type: filters?.salesType,
      sort_by: sorting?.unique_id,
      sort_order: sorting?._id,
    };
    if (offset == 0) {
      dispatchGetOutwardsData(finalData);
      dispatchResetTotalOutwardListCount();
    } else {
      setOffset(0);
    }
  }

  function applyDate(start: string, end: string) {
    dispatchResetOutwardData();
    dispatchResetTotalOutwardListCount();
    setData([]);
    let finalData = {
      token,
      search_term: text,
      offset: 0,
      limit,
      client_code,
      start_date:
        !start || start == "Invalid date"
          ? formatDate(`${currentFY?.split("-")[0]}-04-01`)
          : formatDate(start),
      end_date:
        !end || end == "Invalid date"
          ? formatDate(`${currentFY?.split("-")[1]}-03-31`)
          : formatDate(end),
      exports: filters?.exports,
      sez: filters?.sez,
      sez_tax_payment: filters?.sezTaxPayment,
      place_of_supply: filters?.placeOfSupply?.value,
      sales_type: filters?.salesType,
      sort_by: sorting?.unique_id,
      sort_order: sorting?._id,
    };
    dispatchGetOutwardsData(finalData);
  }

  const handleSearch = (e: any) => {
    setOffset(0);
    setText(e.target.value);
  };
  const addingIsOpen = () => {
    let newData = JSON.parse(JSON.stringify(data));
    newData?.map((item: any) => {
      return (item.isOpen = false);
    });
    setData([...newData]);
  };

  const resetData = () => {
    dispatchResetOutwardData();
    setData([]);
    dispatchResetTotalOutwardListCount();
  };

  const updateOutwardsData = (data: any) => {
    if (
      data?.data_to_update?.hasOwnProperty("gst_exemption") ||
      data?.data_to_update?.hasOwnProperty("reverse_charge")
    ) {
      setOutWardDropDownData(!outWardDropDownData);
    }
    dispatchUpdateOutwardsData(data);
  };

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (
      Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight &&
      !fetching &&
      offset < totalOutwardsListCount
    ) {
      setOffset(offset + limit);
    }
  };

  const onClose = (id: string | number) => {
    setOffset(0);
    dispatchResetOutwardData();
    let filterMultiSelectData = multiSelectData?.filter(
      (item: any) => item._id !== id
    );
    let placeOfSupply = filterMultiSelectData?.find(
      (item: any) => item.unique_id == "placeOfSupply"
    );
    let sez = filterMultiSelectData?.find(
      (item: any) => item.unique_id == "sez"
    );
    let sezTaxPayment = filterMultiSelectData?.find(
      (item: any) => item.unique_id == "sezTaxPayment"
    );
    let salesType = filterMultiSelectData?.find(
      (item: any) => item.unique_id == "salesType"
    );
    let exports = filterMultiSelectData?.find(
      (item: any) => item.unique_id == "exports"
    );

    let writeAbleFilters = JSON.parse(JSON.stringify(filters));
    let writeAbleFiltersValue = JSON.parse(JSON.stringify(filtersValue));
    if (!placeOfSupply) {
      writeAbleFilters["placeOfSupply"] = "";
      writeAbleFiltersValue["placeOfSupply"] = "";
    }
    if (!sez) {
      writeAbleFilters["sez"] = "";
      writeAbleFiltersValue["sez"] = "";
    }
    if (!sezTaxPayment) {
      writeAbleFilters["sezTaxPayment"] = "";
      writeAbleFiltersValue["sezTaxPayment"] = "";
    }
    if (!salesType) {
      writeAbleFilters["salesType"] = "";
      writeAbleFiltersValue["salesType"] = "";
    }
    if (!exports) {
      writeAbleFilters["exports"] = "";
      writeAbleFiltersValue["exports"] = "";
    }
    setFilters({ ...writeAbleFilters });
    setFiltersValue({ ...writeAbleFiltersValue });
    setMultiSelectData([...filterMultiSelectData]);
  };

  const resetSingleData = () => {
    setData([...persistData.current]);
  };

  useEffect(() => {
    if (!fetching) {
      window.addEventListener("scroll", onScroll);
    }

    if (data?.length > 0) {
      addingIsOpen();
    }
    return () => window.removeEventListener("scroll", onScroll);
  }, [outwardsData]);

  useEffect(() => {
    if (offset > 0) {
      if (outwardsData && outwardsData?.length > 0) {
        setData((prv: any) => [...prv, ...outwardsData]);
      }
    } else if (outwardsData) {
      setData(outwardsData);
    }
  }, [outwardsData]);

  useDebounce(
    () => {
      if (text) {
        getData();
      } else {
        setApiCall(true);
        setData([]);
        dispatchResetOutwardData();
        let finalData = {
          token,
          offset,
          search_term: text,
          limit,
          client_code,
          start_date:
            !startDate || startDate == "Invalid date"
              ? formatDate(`${currentFY?.split("-")[0]}-04-01`)
              : formatDate(startDate),
          end_date:
            !endDate || endDate == "Invalid date"
              ? formatDate(`${currentFY?.split("-")[1]}-03-31`)
              : formatDate(endDate),
          exports: filters?.exports,
          sez: filters?.sez,
          sez_tax_payment: filters?.sezTaxPayment,
          place_of_supply: filters?.placeOfSupply?.value,
          sales_type: filters?.salesType,
          sort_by: sorting?.unique_id,
          sort_order: sorting?._id,
        };

        dispatchGetOutwardsData(finalData);
        dispatchResetTotalOutwardListCount();
      }
    },
    500,
    [text]
  );

  const handleStartDateChange = (date: any) => {
    const value = handleDate(date);
    setStartDate(value);
  };

  const handleEndDateChange = (date: any) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
            }}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetGstError();
              dispatchResetGstMessage();
              resetSingleData();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message === "gst outwards entry has been updated!"
    ) {
      dispatchResetGstMessage();
    }
    return false;
  };

  return (
    <div className="gst">
      <OutwardHeader
        filters={filters}
        setFilters={setFilters}
        filtersValue={filtersValue}
        setFiltersValue={setFiltersValue}
        setToggle={setToggle}
        toggle={toggle}
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        text={text}
        totalOutwardsListCount={totalOutwardsListCount}
        handleSetIcon={handleSetIcon}
        handleSearch={handleSearch}
        totalInvoiceValue={totalInvoiceValue}
        sorting={sorting}
        setSorting={setSorting}
        multiSelectData={multiSelectData}
        setMultiSelectData={setMultiSelectData}
        setOffset={setOffset}
        resetData={resetData}
        applyDate={applyDate}
        clientCode={client_code}
        token={token}
        companyName={company_name}
        currentYear={currentYear}
      />
      <Row>
        <Col lg={12} className="ml-2">
          <MultiSelect data={multiSelectData} onClose={onClose} type="gstr" />
        </Col>
      </Row>
      {fetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      ) : outwardsData && outwardsData?.length > 0 ? (
        <div className="table-responsive gstr">
          <table className="table">
            <thead className="sticky-table-header thead-light">
              <GstTotalHeader
                totalCgstAmount={totalCgstAmount}
                totalIgstAmount={totalIgstAmount}
                totalInvoiceValue={totalInvoiceValue}
                totalSgstAmount={totalSgstAmount}
                totalTaxableValue={totalTaxableValue}
                tableHeader={
                  OUTWARD_SUPPLIES_HEADERS
                  // loginData?.group_id === 1
                  //   ? OUTWARD_SUPPLIES_HEADERS
                  //   : OUTWARD_SUPPLIES_HEADERS?.filter(
                  //       (item: any) => item?.value !== "gstr1_type"
                  //     )
                }
              />
              <GstTableHeader
                tableHeader={
                  OUTWARD_SUPPLIES_HEADERS
                  // loginData?.group_id === 1
                  //   ? OUTWARD_SUPPLIES_HEADERS
                  //   : OUTWARD_SUPPLIES_HEADERS?.filter(
                  //       (item: any) => item?.value !== "gstr1_type"
                  //     )
                }
              />
            </thead>
            <tbody>
              <MainTableBody
                type={"outward"}
                token={token}
                history={history}
                client_code={client_code}
                fetching={fetching}
                tableData={data}
                setData={setData}
                tableHeader={
                  OUTWARD_SUPPLIES_HEADERS
                  // loginData?.group_id === 1
                  //   ? OUTWARD_SUPPLIES_HEADERS
                  //   : OUTWARD_SUPPLIES_HEADERS?.filter(
                  //       (item: any) => item?.value !== "gstr1_type"
                  //     )
                }
                itemHeader={ITEM_TABLE_HEADERS}
                updateData={updateOutwardsData}
                persistData={persistData}
                isClickable={isSalesEntryPresent}
              />
            </tbody>
          </table>
        </div>
      ) : (
        <>
          {!fetching && data?.length === 0 && (
            <div className="pb-5 pt-5">
              <EmptyListPage
                title="No Records Found"
                text=""
                showLinkButton={false}
                image={NoFile}
                imageWidth="30%"
              />
            </div>
          )}
        </>
      )}
      {handleErrorModal()}
      <ScrollToTop />
      {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.fetching,
  outwardsData: state.gst.outwardsData,
  totalOutwardsListCount: state.gst.totalOutwardsListCount,
  error: state.gst.error,
  success: state.gst.success,
  message: state.gst.message,
  statusCode: state.gst.statusCode,
  loginData: state.auth.loginData,
  totalCgstAmount: state.gst.totalCgstAmount,
  totalIgstAmount: state.gst.totalIgstAmount,
  totalInvoiceValue: state.gst.totalInvoiceValue,
  totalSgstAmount: state.gst.totalSgstAmount,
  totalTaxableValue: state.gst.totalTaxableValue,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetGstError: () => dispatch(resetGstModuleError()),
  dispatchResetGstSuccess: () => dispatch(resetGstModuleSuccess()),
  dispatchResetGstFetching: () => dispatch(resetGstModuleFetching()),
  dispatchGetOutwardsData: (data: GetOutwardDataPayload) =>
    dispatch(getOutwardsListAction(data)),
  dispatchUpdateOutwardsData: (data: UpdateOutwardDataPayload) =>
    dispatch(updateOutwardListAction(data)),
  dispatchResetGstMessage: () => dispatch(resetGstMessage()),
  dispatchResetOutwardData: () => dispatch(resetOutwardsData()),
  dispatchResetTotalOutwardListCount: () =>
    dispatch(resetTotalOutwardsListCount()),
  dispatchResetGstrOneData: () => dispatch(resetGstrOneData()),
  dispatchResetTotalCgstAmount: () => dispatch(resetTotalCgstAmount()),
  dispatchResetTotalIgstAmount: () => dispatch(resetTotalIgstAmount()),
  dispatchResetTotalInvoiceValue: () => dispatch(resetTotalInvoiceValue()),
  dispatchResetTotalSgstAmount: () => dispatch(resetTotalSgstAmount()),
  dispatchResetTotalTaxableValue: () => dispatch(resetTotalTaxableValue()),
  dispatchResetGstrTwoAData: () => dispatch(resetGstrTwoAReturnsData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OutwardSupplies);
